import { CategoricalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	role: 'role',
	actionsArray: 'actionsArray',
	resources: 'resources'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Role',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.role];
		}
	})
];

export default { columnConfigs, COL_NAMES };
